import { getDefaultApi } from './ChinookApiService';

export const rechercherEntrepriseDansSirene = (siret) =>
         getDefaultApi()
           .rechercherEntreprise(siret)
           .then((response) => response.data);

export const getEntreprise = (uidEntreprise) =>
         getDefaultApi()
           .getEntreprise(uidEntreprise)
           .then((response) => response.data);

export const enregistrerEntreprise = ({ valuesAenvoye }) =>
         getDefaultApi()
           .enregistrerEntreprise(valuesAenvoye)
           .then((response) => response.data);

export const mettreAjourEntreprise = (uidEntreprise, { valuesAenvoye }) =>
         getDefaultApi()
           .updateEntreprise(uidEntreprise, valuesAenvoye)
           .then((response) => response.data);
